<template>
    <div class="bg-white dark:bg-gray-800 px-4 py-3 flex items-center justify-between border-t border-gray-200 dark:border-gray-900 sm:px-6">
        <div v-if="paging.total > 0" class="flex-1 flex flex-col md:flex-row items-center justify-between">
            <div>
                <p class="text-gray-700 dark:text-gray-100">
                    Showing
                    <span class="font-medium">{{ paging.from }}</span>
                    to
                    <span class="font-medium">{{ paging.to }}</span>
                    of
                    <span class="font-medium">{{ paging.total }}</span>
                    results
                </p>
            </div>
            <div class="mt-2 md:mt-0">
                <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
                    <button
                        @click="linkClicked(link.url)"
                        v-for="(link, key) in paging.links"
                        :key="key"
                        class="bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-900 text-gray-500 dark:text-gray-100 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border font-medium"
                        :class="{ 'bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600': link.active }"
                    >
                        <span v-html="link.label"></span>
                    </button>
                </nav>
            </div>
        </div>
        <div v-else class="flex-1 flex flex-col md:flex-row items-center justify-between text-gray-400 dark:text-gray-100">
            No results found.
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import Paginateable from "../types/Paginateable";

export default defineComponent({
    props: {
        paging: {
            type: Object as PropType<Paginateable>,
            required: true
        }
    },
    emits: ["linkClicked"],
    setup(_, context) {
        function linkClicked(link: string | undefined) {
            context.emit("linkClicked", link);
        }

        return {
            linkClicked
        }
    }
})
</script>
